import axios from "axios";
import { feathers } from '@/feathers-client';
import campaignTableHeaders from './../config/table-headers/campaigns';
/*
 * The campaigns table module
 */
export default {
  namespaced: true,
  state: {
    campaign: {
      name: '',
    },
    newCampaign: null,
    campaigns: [],
    error: null,
    totals: 0,
    isLoading: null,
    headers: campaignTableHeaders,
  },

  getters: {
    // for use in dropdown menus
    campaignsList(state) {
      const removeCampaignOption = {
        value: 0,
        text: 'None',
      };
      const campaigns = state.campaigns.map(campaign => {
        return { value: campaign.id, text: campaign.name };
      });
      return [removeCampaignOption, ...campaigns];
    },
    campaigns(state, getters) {
      if (state.campaigns && getters.visibleFields) {
        const newCampaignsList = state.campaigns.map(contact => {
          return Object.assign({}, ...getters.visibleFields.map(key => ({
            [key]: contact[key],
          })));
        });
        return newCampaignsList;
      }
    },
    headers(state) {
      const { headers } = state;
      const headerArray = Object.keys(headers).filter(header => {
        return headers[header].visible && headers[header].text && headers[header].text.length > 0;
      }).map(header => {
        return {
          text: headers[header].text,
          value: header,
          visible: headers[header].visible,
          align: 'center',
          sortable: headers[header].sortable || false,
        };
      });
      return headerArray;
    },
    visibleFields(state) {
      const { headers } = state;
      const visibleFields = Object.keys(headers).filter(header => {
        return headers[header].visible;
      }).map(header => {
        return header;
      });
      return visibleFields;
    },
  },

  mutations: {
    setNewCampaign(state, payload) {
      state.newCampaign = payload;
    },
    setCampaigns(state, payload) {
      state.campaigns = payload;
    },
    setCampaign(state, payload) {
      state.campaign = payload;
    },
    setTotals(state, payload) {
      state.totals = payload;
    },
    setCampaignError(state, payload) {
      state.error = payload;
    },
    setIsLoading(state, payload) {
      state.isLoading = payload;
    },
  },

  actions: {
    async disconnect({ dispatch, rootState }) {
      await feathers.service('/users').patch(rootState.userInformation.user.id, {
        structurely_forwarding_email: '',
      });

      dispatch('userInformation/getUser', null, { root: true });
    },
    // formatCampaignData({ commit, getters, state }, payload) {
    //   const campaigns = payload.map(item => {
    //     if (item.is_shared_by_broker) {
    //       const newName = `${item.name} (Shared by Admin)`;
    //       item.name = newName;
    //     }
    //     return item;
    //   });
    //   commit('setCampaigns', campaigns);
    //   commit('setIsLoading', false);
    // },
    async createCampaign({ dispatch, commit, getters, state }, payload) {
      const request = {
        name: payload,
      };
      let response;
      try {
        response = await feathers.service('campaigns').create(request);
        if (response && response.id) {
          commit('setNewCampaign', response);
          return response;
        }
      } catch (error) {
        commit('setCampaignError', error);
      }
    },
    async getCampaign({ dispatch, commit, getters, state }, id) {
      let response;
      try {
        response = await feathers.service('campaigns').get(id);
        commit('setCampaign', response);
      } catch (error) {
        commit('setCampaignError', error);
      }
    },
    async removeCampaign({ dispatch, commit, getters, state }, payload) {
      const { id, query } = payload;
      try {
        await feathers.service('campaigns').remove(id);
      } catch (error) {
        commit('setCampaignError', error);
      }
      dispatch('findCampaigns', query);
    },
    async bulkDeleteCampaigns({ commit }, payload) {
      commit('setIsLoading', true);
      try {
        await axios.put(`${process.env.VUE_APP_ACCOUNTS_API}/users/campaigns/bulk-delete`, payload);
      } catch (error) {
        commit('setCampaignError', error);
      } finally {
        commit('setIsLoading', false);
      }
    },
    async editCampaign({ dispatch, commit }, payload) {
      let response;
      try {
        const { id: campaignId, ...updatedCampaign } = payload;
        commit('setIsLoading', true);
        response = await feathers.service('campaigns').patch(campaignId, updatedCampaign);
        commit('setCampaign', response);
        commit('setIsLoading', false);
        dispatch('findCampaigns');
      } catch (error) {
        commit('setCampaignError', error);
      }
    },
    async cloneCampaign({dispatch, commit}, payload) {
      try {
        const { id: campaignId, query } = payload;
        commit('setIsLoading', true);
        await axios.post(`${process.env.VUE_APP_ACCOUNTS_API}/users/campaigns/${campaignId}/clone`);
        dispatch('findCampaigns', query);
      } catch (error) {
        commit('setCampaignError', error);
      } finally {
        commit('setIsLoading', false);
      }
    },
    async findCampaigns({ commit, dispatch, getters, state }, query = {}) {
      let response;
      try {
        commit('setIsLoading', true);
        response = await feathers.service('campaigns').find({ query });
        // dispatch('formatCampaignData', response.data);
        commit('setTotals', response.total);
        commit('setCampaigns', response.data);
        commit('setIsLoading', false);
      } catch (error) {
        commit('setCampaignError', error);
      }
    },
    async stopCampaign({ commit }, payload) {
      try {
        commit('setIsLoading', true);
        await axios.post(`${process.env.VUE_APP_ACCOUNTS_API}/users/campaigns/bulk-stop`, payload);
      } catch(error) {
        commit('setCampaignError', error);
      } finally {
        commit('setIsLoading', false);
      }
    },
  },
};
